export const SUPPORTED_ENTRY_TYPES = [
    'audio',
    'video',
    'text',
    'archive',
    'folder',
    'shared-folder',
    'image',
    'powerPoint',
    'word',
    'spreadsheet',
    'zip-archive',
    'rar-archive',
    'iso',
    'mp3',
    'mp4',
    'png',
    'avi',
    'pdf',
    'gif',
    'bin',
    'wav',
    'txt',
    'tiff',
    'html',
    'jpg',
    'torrent',
    'apk'
];
